var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmex(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#006DD2",
    d: "M4 20h16V4H4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M19.215 6.45h-1.674l-.148.431-.345 1.001-.344-1-.149-.431h-3.098v2.024l-.703-1.637-.166-.387h-2.412l-.17.376-2.03 4.5-.408.903H9.69v5.206h6.292l.19-.2.875-.918.876.918.188.2H20v-1.568l-1.26-1.323L20 13.223V6.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006DD2",
    d: "M10.751 9.687l.591-1.377.621 1.377h-1.212zm2.071 1.904h1.275l-1.93-4.501H10.59l-2.03 4.501h1.375l.389-.908h2.088l.41.908zm5.176-4.501l-.95 2.76-.95-2.76h-2.001v4.5h1.282V8.538l1.05 3.052h1.24l1.049-3.052v3.052H20v-4.5zm-3.901 6.28v-1.075h-3.77v4.5h3.77v-1.074H11.61v-.638h2.487v-1.075H11.61v-.638z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006DD2",
    d: "M18.386 12.295L17.048 13.7l-1.339-1.404h-1.612l2.144 2.25-2.144 2.251h1.612l1.34-1.404 1.337 1.404H20l-2.146-2.25L20 12.295z"
  }))));
}

export default SvgAmex;